import { useForm } from "@mantine/form";
import { PasswordInput, TextInput, Button, Loader, Center, Flex } from "@mantine/core";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { getAdminUserById, updateAdminUserById } from "../../api/adminUserApi";
import { updateNotification } from "../../utils/useNotification";
import styled from "styled-components";
import Container from "../common/Container";
import { ActionIcon } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
// `import { OnSubmit } from "@mantine/form/lib/types"` KALDIRILDI (plan 2.37):
// tip hiçbir yerde kullanılmıyordu ve yol zaten çözülemiyor — `@mantine/form`
// (7.x) `exports` haritasında yalnızca "." var, yani `lib/types` diskte durduğu
// hâlde erişilebilir bir giriş noktası değil. Tip-only import olduğu için Babel
// siliyor ve build hiç fark etmiyordu; `tsc` koşmadığı için de yakalanmamıştı.
import {
  combineValidators,
  validateMinLength,
  validateNoSpaces,
  validatePhoneNumberIsNumeric,
  validatePhoneNumberStartsWithZero,
  validateRequired,
  validateMaxLength,
} from "../../utils/validations";

const AdminUsersUpdateForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const form = useForm({
    initialValues: {
      username: "",
      name: "",
      phone: "",
      password: "",
    },
    validate: {
      name: validateRequired,
      phone: combineValidators(
        validateRequired,
        validatePhoneNumberStartsWithZero,
        validatePhoneNumberIsNumeric,
        validateNoSpaces,
        validateMinLength(11)
      ),
    },
  });

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res: any = await getAdminUserById({ id });
        const userData = res?.data?.response;

        if (userData) {
          form.setValues({
            username: userData.username ?? "",
            name: userData.name ?? "",
            phone: userData.phone?.startsWith("+90")
              ? "0" + userData.phone.slice(3)
              : userData.phone ?? "",
            password: "",
          });
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchUser(); 
  }, [id]); 

  const handleSubmit = async (values: any) => {
    console.log("Submit tetiklendi!", values);
    try {
      const updates = { ...values };
      if (!updates.password) delete updates.password;

      const res: any = await updateAdminUserById({
        id: id,
        updates: updates,
      });
      console.log("API response:", res); 

      if (res?.data?.success || res?.status === 200) {
        updateNotification(res?.data?.success || "Kullanıcı Güncellendi");
        navigate("/admin-users");
      }
    } catch (error) {
      console.error("Güncelleme hatası:", error);
    }
  };

  if (loading) return <Center h={400}><Loader color="#5C26FF" /></Center>;

  return (
    <Container>
      <ActionIcon 
        variant="subtle" 
        color="#5c26ff" 
        size={44}
        onClick={() => navigate("/admin-users")} 
      >
        <IconArrowLeft size={28} />
      </ActionIcon>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "40px",
          alignItems: "center",  
          justifyContent: "center", 
          minHeight: "70vh", 
          width: "100%", 
        }}
      >
        <PageTitle>
          <Title>Admin Kullanıcısı Bilgileri Güncelleme</Title>
        </PageTitle>

        <form
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            width: "min(468px, 100%)", 
          }}
          onSubmit={form.onSubmit(handleSubmit)}
        >
          <TextInput
            label="Kullanıcı Adı"
            radius={10}
            size="md"
            {...form.getInputProps("username")}
          />
          <TextInput
            label="Ad Soyad"
            radius={10}
            size="md"
            {...form.getInputProps("name")}
          />
          <TextInput
            label="Telefon"
            radius={10}
            size="md"
            maxLength={11}
            {...form.getInputProps("phone")}
          />
          <PasswordInput
            label="Şifre"
            placeholder="Değiştirmek istemiyorsanız boş bırakın."
            radius={10}
            size="md"
            {...form.getInputProps("password")}
          />

          <Flex gap={10} mt={10}>
            <Button 
              variant="outline" 
              color="gray" 
              radius={10} 
              fullWidth 
              onClick={() => navigate("/admin-users")}
            >
              Vazgeç
            </Button>
            <Button 
              color="#5C26FF" 
              radius={10} 
              type="submit" 
              fullWidth
              disabled={!form.isDirty()}
            >
              Güncelle
            </Button>
          </Flex>
        </form>
      </div>
    </Container>
  );
};

export default AdminUsersUpdateForm;

const PageTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 12px;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  color: black;
`;